import type { IconSvgProps } from '../Icon.types';

export const InfoFilled = ({ fill, width, height, className }: IconSvgProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 11.5C7.86739 11.5 7.74021 11.4473 7.64645 11.3536C7.55268 11.2598 7.5 11.1326 7.5 11V8C7.5 7.86739 7.55268 7.74021 7.64645 7.64645C7.74021 7.55268 7.86739 7.5 8 7.5C8.13261 7.5 8.25979 7.55268 8.35355 7.64645C8.44732 7.74021 8.5 7.86739 8.5 8V11C8.5 11.1326 8.44732 11.2598 8.35355 11.3536C8.25979 11.4473 8.13261 11.5 8 11.5ZM8.75 5.5C8.75 5.69891 8.67098 5.88968 8.53033 6.03033C8.38968 6.17098 8.19891 6.25 8 6.25C7.80109 6.25 7.61032 6.17098 7.46967 6.03033C7.32902 5.88968 7.25 5.69891 7.25 5.5C7.25 5.30109 7.32902 5.11032 7.46967 4.96967C7.61032 4.82902 7.80109 4.75 8 4.75C8.19891 4.75 8.38968 4.82902 8.53033 4.96967C8.67098 5.11032 8.75 5.30109 8.75 5.5Z"
      fill={fill}
    />
  </svg>
);
